// extracted by mini-css-extract-plugin
module.exports = {"htmlContainer":"ManualTaskTable_htmlContainer_2hc9X"};